import { Card } from '@/components/ui';
import { MasterAuditInfo, type MasterAuditInfoProps } from './MasterAuditInfo';

/**
 * The Audit tab of a master screen: who made the record, and who last touched it.
 *
 * Seven screens wrote the same card, the same heading, the same six-prop spread and the same
 * sentence for a record that does not exist yet. The cost centre screen wrote something else
 * entirely — a two-column grid of tiles under a "Record Information" heading — so the one tab whose
 * whole job is to look the same everywhere was the tab that did not.
 *
 * Takes the record rather than nine separate props: every master DTO already carries these fields,
 * and spreading them one by one at eight call sites is how two of them ended up missing
 * `modifiedByName`.
 */
export const MasterAuditTab = ({ record }: { record: MasterAuditInfoProps | null }) => (
  <Card>
    <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-4">
      Audit Information
    </h3>
    {record ? (
      <MasterAuditInfo {...record} />
    ) : (
      <p className="text-sm text-gray-400 italic">
        Audit information will appear after the record is saved.
      </p>
    )}
  </Card>
);
